import { combineReducers } from 'redux';

import appReducer from './data/reducer';
import saga from './data/sagas';
import { reducer as drawersReducer } from './drawers/index';
import entitiesReducer from './entities/reducer';

const reducer = combineReducers({
  app: appReducer,
  data: entitiesReducer,
  drawers: drawersReducer,
});

export { reducer, saga };
